var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNextInactive = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  stroke: "#1C498E",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C498E",
  fillRule: "nonzero",
  d: "M6.504 3 5.5 4.004l3.259 3.259L5.5 10.52l1.004 1.004 4.263-4.262z"
}))));
export { SvgIconNextInactive as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-next-inactive.svg";